import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const TeamPrivateRoute = ({ children }) => {
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    const verify = async () => {
      const token = localStorage.getItem('team_token');
      if (!token) { setStatus('unauthorized'); return; }
      try {
        const { data } = await axios.get(`${API_BASE_URL}/owner/team/verify`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        localStorage.setItem('team_member', JSON.stringify(data.member));
        setStatus('authorized');
      } catch {
        localStorage.removeItem('team_token');
        localStorage.removeItem('team_member');
        setStatus('unauthorized');
      }
    };
    verify();
  }, []);

  if (status === 'loading') {
    return (
      <div className="flex items-center justify-center h-screen bg-[#060a14] text-green-400 text-xl">
        جاري التحقق...
      </div>
    );
  }

  return status === 'authorized' ? children : <Navigate to="/team-login" />;
};

export default TeamPrivateRoute;
